module.exports = "/assets/dist/img/letter-jacket-placeholder-image.jpg?9225019bbafd4b91795d21c827677b58";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/letter-jackets/catalog-details/assets/letter-jacket-placeholder-image.jpg
// module id = 1311
// module chunks = 0